import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { CalendarCheck } from "@phosphor-icons/react";

const STATUSES = ["pending", "confirmed", "completed", "cancelled"];
const COLORS = {
  pending: "bg-amber-100 text-amber-700",
  confirmed: "bg-blue-100 text-blue-700",
  completed: "bg-teal/15 text-teal-dark",
  cancelled: "bg-slate-100 text-slate-500",
};

export function BookingsManager() {
  const [items, setItems] = useState([]);
  const load = useCallback(
    () => api.get("/admin/bookings").then((r) => setItems(r.data)).catch((e) => console.error("Failed to load bookings:", e)),
    []
  );
  useEffect(() => { load(); }, [load]);

  const setStatus = async (id, status) => {
    try {
      await api.patch(`/admin/bookings/${id}`, { status });
      toast.success("Booking updated");
      load();
    } catch {
      toast.error("Update failed");
    }
  };

  return (
    <div className="space-y-3" data-testid="admin-bookings-manager">
      <h3 className="font-heading text-lg font-semibold text-ink">Consultation bookings ({items.length})</h3>
      {items.map((b) => (
        <div key={b.id} className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white p-4" data-testid={`admin-booking-${b.id}`}>
          <div className="min-w-[220px]">
            <div className="flex items-center gap-2">
              <p className="font-heading text-sm font-semibold text-ink">{b.name}</p>
              <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold capitalize ${COLORS[b.status] || COLORS.pending}`}>{b.status}</span>
            </div>
            <p className="text-xs text-slate-400">{b.email}{b.phone ? ` · ${b.phone}` : ""}</p>
            {b.topic && <p className="mt-0.5 text-xs text-slate-500">{b.topic}</p>}
          </div>
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1.5 rounded-md bg-mist px-3 py-1.5 font-mono text-xs font-semibold text-ink">
              <CalendarCheck size={14} className="text-teal" /> {b.date} · {b.time}
            </span>
            <select
              value={b.status}
              onChange={(e) => setStatus(b.id, e.target.value)}
              data-testid={`booking-status-${b.id}`}
              className="rounded-md border border-slate-200 px-2 py-1.5 text-xs capitalize outline-none focus:border-teal"
            >
              {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
        </div>
      ))}
      {items.length === 0 && <p className="rounded-xl border border-dashed border-slate-300 bg-white p-8 text-center text-sm text-slate-400">No bookings yet.</p>}
    </div>
  );
}
